import { useUI } from "providers/UIProvider";

import { BOOKING_FEE_TABS } from "types/shared";

import Tabs from "components/UI/molecules/Tabs";
import { useSettings } from "providers/SettingsProvider/SettingsProvider";
import useBookingFee from "hooks/useBookingFee";

const BookingFeeTabs = () => {
  const { T } = useUI()
  const { commissionTabType } = useSettings()
  const { handleTabChange } = useBookingFee()
  
  return (
    <Tabs
      items={[
        {
          key:  BOOKING_FEE_TABS.PERCENT,
          value: T("booking_fee.tabs.percent_title"),
          valueIcon: "bookingFee"
        },
        {
          key: BOOKING_FEE_TABS.FIXED,
          value: T("booking_fee.tabs.fixed_title"),
          valueIcon: "currency_GEl",
          renderContent: true,
          content: "₾"
        }
      ]}
      currentTab={commissionTabType}
      handleTabChange={handleTabChange}
    />
  )
}

export default BookingFeeTabs